export default "__VITE_ASSET__D4pt6Vin__"